<template>
    <div class="category-filter skip-latin-class" >
        <div v-if="isMobile" id="categoryHeader">
            <button class="accordion-toggle" data-toggle="collapse" data-target="#categoryList" aria-expanded="true" aria-controls="categoryList">
                <h3>
                    {{pointStore.categories.Heading}} <span class="icon-arrow"></span>
                </h3>
            </button>
        </div>
        <h3 v-else>{{pointStore.categories.Heading}}</h3>
        <div id="categoryList" :class="isMobile ? 'collapse in' : 'filter-open'" aria-labelledby="categoryHeader">
            
          <div class="category" :class="[category.Disabled ? 'disabled' : '', category.Selected ? 'selected' : '']" 
          v-on:click="toggleCategory(category)" v-for="category in pointStore.categories.List" v-bind:key="category.Id">
              <span :class="category.IconClass"></span>
              <p class="category__title">{{category.Name}}</p>
          </div>
            
        </div>
    </div>
    
</template>

<script setup>
    import { usePointStore } from '../store/store';
    const pointStore = usePointStore();

    const props = defineProps({
        categories: Object,
        isMobile: Boolean
    });
   
    const emit = defineEmits([
        'clicked', 
        'toggleCategory'
    ]);
    function toggleCategory(category) {
        emit('clicked', category);
        emit('toggleCategory', category);
    }
    
    
</script>